<div [class.active]="ifShowPreloader"
	class="preloader">
	<div class="preloader__1">THE WORK</div>
	<div class="preloader__2">THE WORK</div>
</div>
